import { render, staticRenderFns } from "./kiosk_token_edit.vue?vue&type=template&id=1c1cb2b1&"
import script from "./kiosk_token_edit.vue?vue&type=script&lang=js&"
export * from "./kiosk_token_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports